var eventArchive = {
    bindings : {
        moreLabel : '@',
        archiveLabel : '@',
        archiveHref : '@',
        pageSize : '@'
    },
    controller : function EventArchiveCtrl (DataService) {
        function init () {
            ctrl.limit = 10;

            // Tell service to load all (on the calender) or to load a limited number (default behaviour in the footer)

            DataService.getArchive('event', ctrl.pageSize)
                .then(onGetArchiveSuccess, onGetArchiveError);
        }

        function link () {

        }

        function onGetArchiveSuccess (response) {
            console.log("onGetArchiveSuccess", response);
            data = response.data;
            var month;
            ctrl.items = [];
            _.each(response.data.posts, function createItem (post) {
                // console.log(month, moment(post.date, 'YYYY-MM-DD H:m:s').month());
                if (angular.isUndefined(month) || month != moment(post.date, 'YYYY-MM-DD H:m:s').month()) {
                    month = moment(post.date, 'YYYY-MM-DD H:m:s').month();
                    post.month = moment(post.date).format('MMMM YY');
                }
                ctrl.items.push(post);
            });
        }

        function onGetArchiveError (error) {
            console.log("onGetArchiveError", error);
        }

        var ctrl = this;
        var data;

        this.showMore = function () {
            ctrl.limit = ctrl.items.length;
        }

        this.$onInit = init;
        this.$postLink = link;
    },
    templateUrl : themeUrl + '/assets/static/html/event-archive.component.html',
};